import React, { Component } from "react";
import "./Catalogue.css";
import { connect } from "react-redux";
import { Row, Col, Container } from "react-bootstrap";
import * as actions from "../../Store/Actions/index";
import Book from "../../Components/Books/Books";
import Spinner from "../../Components/UI/Spinner/Spinner";
import MobileFilter from "../../Components/MobileFilter/MobileFilter";
import FilterMenu from "../../Components/Filters/FilterMenu/FilterMenu";
import Footer from "../../Components/Footer/Footer";
import Breadcrumbs from "react-router-dynamic-breadcrumbs";
import { Link as Router } from "react-router-dom";

class Catalogue extends Component {
  state = {
    index: 1,
    total: 10,
    page: "",
    isChecked: new Map(),
    gradeListOpen: true,
    subjectListOpen: true,
    boardListOpen: true,
    filterOption: [],
    classes: [],
    subjects: [],
    boards: [],
    mobileFilters: false,
    sentPayload: [],
    routes: {
      "/": "Home",
      "/catalogue": "Catalogue",

      // '/users/:id/info': 'User Info',
      // '/users/:id/posts/:p_id': 'Post :p_id by :id', // backreferences will be replaced by correspoding parts of url
    },
  };

  toggleList(type) {
    if (type === "grade") {
      this.setState((prevState) => ({
        gradeListOpen: !prevState.gradeListOpen,
      }));
    }
    if (type === "subject") {
      this.setState((prevState) => ({
        subjectListOpen: !prevState.subjectListOpen,
      }));
    }
    if (type === "board") {
      this.setState((prevState) => ({
        boardListOpen: !prevState.boardListOpen,
      }));
    }
  }

  setFilterHandler = (e, id, type, index) => {
    var isChecked = e.target.checked;
    if (isChecked) {
      if (type === "class") {
        this.state.classes.push(id);
      }
      if (type === "subjects") {
        this.state.subjects.push(id);
      }
      if (type === "boards") {
        this.state.boards.push(id);
      }
    } else {
      if (type === "class") {
        this.state.classes.splice(this.state.classes.indexOf(id), 1);
      }
      if (type === "subjects") {
        this.state.subjects.splice(this.state.subjects.indexOf(id), 1);
      }
      if (type === "boards") {
        this.state.boards.splice(this.state.boards.indexOf(id), 1);
      }
    }
    if (
      this.state.classes.length > 0 ||
      this.state.subjects.length > 0 ||
      this.state.boards.length > 0
    ) {
      let payload = {
        classes: this.state.classes,
        subjects: this.state.subjects,
        boards: this.state.boards,
      };
      this.props.savePayload(payload);
      this.props.setFilter(payload);
    }
  };

  // componentWillMount() {
  //   this.props.GetBookByInputType(this.state.bookInputType);
  // }

  componentDidMount() {
    this.props.getGrade();
    this.props.getSubject();
    this.props.getBoard();
    if (this.props.inputBookType === "allBooks") {
      this.props.getBooks();
    } else {
      this.props.getGoogleBooks();
    }
  }

  Prev = () => {
    if (this.state.index === 1) {
      return;
    } else {
      this.slide(-1);
      this.props.getPaginatedBooks(
        this.props.savedPayload,
        this.state.index,
        this.props.inputBookType
      );
    }
  };
  Next = () => {
    if (this.state.index === this.props.totalPage) {
      return;
    } else {
      this.slide(1);
      this.props.getPaginatedBooks(
        this.props.savedPayload,
        this.state.index,
        this.props.inputBookType
      );
    }
  };
  slide = (offset) => {
    this.state.index = Math.min(
      Math.max(this.state.index + offset, 0),
      this.props.totalPage
    );
    let updatedPage = this.state.index + 1 + " / " + this.state.total;
    this.setState({ page: updatedPage });
  };

  showMobileFilter = () => {
    this.setState({
      mobileFilters: true,
    });
    var element = document.getElementById("catalogueContainer");
    element.classList.add("overFlowHidden");
  };

  hideMobileFilter = () => {
    this.setState({
      mobileFilters: false,
    });
    var element = document.getElementById("catalogueContainer");
    element.classList.remove("overFlowHidden");
  };
  render() {
    let bookRender = this.props.loading ? (
      <Spinner />
    ) : (
      this.props.books.map((book, index) => {
        return (
          <Col
            className="bookComponentContainer"
            key={index}
            xs={6}
            sm={4}
            md={5}
            lg={3}
          >
            <Book content={book} />
          </Col>
        );
      })
    );
    document.title =
      "VK Global Publications | Buy our latest editions of CBSE textbooks and exam preparation books";
    return (
      <div>
        <MobileFilter
          currentState={this.state.mobileFilters}
          hide={this.hideMobileFilter}
          page={this.state.index}
        />

        <div id="catalogueContainer" className="catalogueSection ">
          {this.props.paginationAval ? (
            <span className="pagination  float-right">
              <i
                onClick={this.Prev}
                className="fas fa-chevron-left leftBtn left"
              ></i>
              {this.state.index + " / " + this.props.totalPage}
              <i
                onClick={this.Next}
                className="fas fa-chevron-right rightBtn right"
              ></i>
            </span>
          ) : (
            ""
          )}
          <Container>
            <h3 className=" SABreadCrumb cataloguebreadcrumbs float-right">
              <Router>
                <Breadcrumbs mappedRoutes={this.state.routes} />
              </Router>
            </h3>
            <h3 className="about-us">Catalogue</h3>

            <Row className="catalogueRowContainer">
              <Col md={3}>
                <div className="catalogueBox ">
                  <div className="filterMenu">
                    <i className="icon dripicons-checklist"></i>
                    <span> Filters</span>
                  </div>
                  <FilterMenu
                    type="grade"
                    state={this.state.gradeListOpen}
                    toggleDropDown={(type) => this.toggleList(type)}
                    callFilter={(event, id, type, index) =>
                      this.setFilterHandler(event, id, type, index)
                    }
                  />
                  <FilterMenu
                    type="subject"
                    state={this.state.subjectListOpen}
                    toggleDropDown={(type) => this.toggleList(type)}
                    callFilter={(event, id, type, index) =>
                      this.setFilterHandler(event, id, type, index)
                    }
                  />
                  <FilterMenu
                    type="board"
                    state={this.state.boardListOpen}
                    toggleDropDown={(type) => this.toggleList(type)}
                    callFilter={(event, id, type, index) =>
                      this.setFilterHandler(event, id, type, index)
                    }
                  />
                </div>
              </Col>
              <Col className="book-container" sm={9}>
                <div className="mobileFilter">
                  <button
                    className="btn filterButton"
                    onClick={this.showMobileFilter}
                  >
                    <i className="icon dripicons-checklist"></i> FILTERS
                  </button>
                  {this.props.paginationAval ? (
                    <span className="pagination mobilePagination float-right">
                      <i
                        onClick={this.Prev}
                        className="fas fa-chevron-left leftBtn left"
                      ></i>
                      {this.state.index + " / " + this.props.totalPage}
                      <i
                        onClick={this.Next}
                        className="fas fa-chevron-right rightBtn right"
                      ></i>
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <Row className="catalogueRow">{bookRender}</Row>
              </Col>
            </Row>
          </Container>
          <br />
          <Footer />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    classList: state.filterMenu.gradeList,
    subjectList: state.filterMenu.subjectList,
    boardList: state.filterMenu.boardList,
    books: state.book.books,
    loading: state.book.loading,
    totalPage: state.book.totalPage,
    savedPayload: state.book.savePayloadData,
    paginationAval: state.book.paginationAval,
    inputBookType: state.book.inputBookType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getGrade: () => dispatch(actions.fetchGradeList()),
    getSubject: () => dispatch(actions.fetchSubjectsList()),
    getBoard: () => dispatch(actions.fetchBoardList()),
    getBooks: (bookType) => dispatch(actions.fetchBooks(bookType)),
    setFilter: (dataToBeFiltered) =>
      dispatch(actions.filterBooks(dataToBeFiltered)),
    savePayload: (payload) => dispatch(actions.savePayload(payload)),
    getPaginatedBooks: (payload, page, bookType) =>
      dispatch(actions.getPaginatedBooks(payload, page, bookType)),
    getGoogleBooks: () => dispatch(actions.fetchGooglePlayBooks()),
    GetBookByInputType: (type) => dispatch(actions.GetBookByInputType(type)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Catalogue);
